import axios from 'axios'

import { Env, getEnv } from '@cinch/oxd-utils/env/src'

const googleMapsService = axios.create({ baseURL: 'https://maps.googleapis.com/maps/api' })
const APIKEY = getEnv(Env.GoogleMapsApiKey)

export const geocode = (address: string) => {
  return googleMapsService.request<{ results: google.maps.GeocoderResult[]; status: google.maps.GeocoderStatus }>({
    method: 'GET',
    url: `/geocode/json`,
    params: {
      address,
      key: APIKEY,
      region: 'uk',
      bounds: '49.00,-13.00|60.00,3.00',
    },
  })
}
